import Card from "../shared/Card/Card";
import Gauge from "components/charts/Gauge/Gauge";
import { useState, useEffect } from "react";
import { Item } from "types/common";
import { getTagData } from "api/tags";
import Area from "components/charts/Area/Area";
import areaApiConfig from "config/charts/areaApiConfig";
import classNames from "utilities/ClassNames";
import { FiX, FiSettings } from "react-icons/fi";
import { useContext } from "react";
import { ModalContext } from "hooks/ModalProvider";

const SRACModal = ({ onClose, onEdit, mode = 'generic' }: { onClose?: any, onEdit?: any, mode?: 'generic' | 'unity' }) => {
  const [randomTag, setRandomTag] = useState<Item | null>(null);
  const [selectedTab, setSelectedTab] = useState('genInfo');
  const [serverTableData, setServerTableData] = useState<any[]>([]);
  const [selectedSlot, setSelectedSlot] = useState('Server');
  const [graphName, setGraphName] = useState('Power Consumption');
  const [selectedTableTab, setSelectedTableTab] = useState('graph');
  const { setCracModalShown } = useContext(ModalContext);

  const serverData = [
    { label: "Device name", value: `${selectedSlot}-HP-DL360p` },
    { label: "Type", value: `${selectedSlot}` },
    { label: "Model HP", value: "PrioLiant DL360p Gen8" },
    { label: "Serial Number", value: "SN12345678" },
    { label: "Vendor", value: "Hewlett-Packard" },
  ];

  const getSingleTag = async () => {
    const randomTagData = await getTagData([244]);
    setRandomTag(randomTagData.data[0]);
  };

  useEffect(() => {
    getSingleTag();
  }, []);

  useEffect(() => {
    setServerTableData(serverData);
  }, [graphName, selectedSlot]);

  useEffect(() => {
    if (selectedTab === 'genInfo') {
      setServerTableData(serverData);
    } else {
      setServerTableData([]);
    }
  }, [selectedTab]);

  const tabs = [
    {
      id: 'genInfo',
      label: 'General Informatio',
      content: null
    },
  ];

  const tableTabs = [
    {
      id: 'graph',
      label: 'Graph',
      content: null
    },
    {
      id: 'alarm',
      label: 'Alarm List',
      content: null
    }
  ];

  return (
    <div className="h-screen w-screen bg-black/65 flex items-center justify-center fixed left-0 top-0 z-50"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onMouseMove={(e) => e.stopPropagation()}
      onWheel={(e) => e.stopPropagation()}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div className="h-[90%] max-w-[700px] xl-2xl:max-w-[600px] 2xl:max-w-[700px] w-full bg-dark px-3 py-2 flex flex-col gap-2 overflow-hidden relative">
        <div className="absolute right-4 top-4 flex items-center justify-center">
          <div className="flex gap-2">
            <button
              className="cursor-pointer bg-blue rounded-md p-0.5 2xl:p-1"
              onClick={() => {
                setCracModalShown(false);
                if (onClose) {
                  onClose();
                }
              }}
            >
              <FiX size={20} />
            </button>
            {mode === 'unity' && onEdit &&
              <button
                className="cursor-pointer bg-blue rounded-md p-0.5 2xl:p-1"
                onClick={() => onEdit()}
              >
                <FiSettings size={20} />
              </button>
            }
          </div>
        </div>
        <div>
          {randomTag && <Card title="CRAC - 4" className="w-[50%]">
            <div className="flex max-h-[18vh] 2xl:max-h-[19vh] min-h-0">
              <div>
                <Gauge
                  data={{ ...randomTag, name: 'Supply Air' }}
                  gaugeType={"regular"}
                />
              </div>
              <div>
                <Gauge
                  data={{ ...randomTag, name: 'Return Air' }}
                  gaugeType={"regular"}
                />
              </div>
              <div>
                <Gauge
                  data={{ ...randomTag, name: 'Humidity' }}
                  gaugeType={"regular"}
                />
              </div>
            </div>
          </Card>}
        </div>
        <div>
          <div className="flex gap-2 w-full min-h-0" style={{ flex: 1 }}>
            <Card title="Filter Condition">
              <div className="p-2 h-full w-full">
                <div className="text-3xl 2xl:text-4xl text-green h-[70%] pb-4">37.7C</div>
              </div>
            </Card>

            {/* <Card title="Humidity">
              <div className="p-2 h-full w-full">
                <div className="text-3xl 2xl:text-4xl text-green h-[70%] pb-4">45.7%</div>
              </div>
            </Card> */}

            <Card title="Overall Status">
              <div className="p-2 h-full w-full">
                <div className="text-3xl 2xl:text-4xl text-green h-[70%] pb-4">99.3%</div>
              </div>
            </Card>
          </div>
        </div>
        <div>
          <div className="">
            <div className="py-1 2xl:py-2 bg-black rounded-lg px-4 flex flex-col overflow-hidden">
              <div className="flex gap-2 mb-2">
                {tabs.map((tab) =>
                  <div onClick={() => setSelectedTab(tab.id)} key={tab.id} className={`px-2 py-0.5 2xl:py-1  bg-[#373d7e] rounded-md hover:bg-gray-100 cursor-pointer ${selectedTab === tab.id ? 'bg-gradient-to-r from-[#7ED34E] to-[#2E968A] text-white' : ''}`}>
                    <h3 className="text-[12px] font-medium">{tab.label}</h3>
                  </div>
                )}
              </div>
              <table className="w-full min-h-[170px] 2xl:min-h-[180px] overflow-y-scroll">
                <tbody className="w-full px-4 h-full">
                  {serverTableData && serverTableData.map(({ label, value }, index) => (
                    <tr
                      key={label}
                      className={`px-2 w-full ${index !== serverData.length - 1 ? "border-b border-[#3b5c74]" : ""}`}
                    >
                      <td className="p-0 2xl:p-0.5 px-0 text-xs 2xl:text-[18px]">{label}</td>
                      <td className="p-0 2xl:p-0.5 px-0 text-end text-xs 2xl:text-[18px]">{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {randomTag &&
          <div className="flex-1 overflow-hidden">
            <div className={classNames(selectedTableTab === 'graph' ? "" : "h-full", "py-2 bg-black rounded-lg px-4 overflow-hidden")}>
              <div className="flex relative gap-2 2xl:mb-2">
                <div className="h-full w-full absolute top-0 left-0">
                  <div className="flex h-max gap-2">
                    {tableTabs.map((tab) =>
                      <div onClick={() => setSelectedTableTab(tab.id)} key={tab.id} className={`px-2 py-0.5 2xl:py-1 bg-[#373d7e] rounded-md hover:bg-gray-100 cursor-pointer ${selectedTableTab === tab.id ? 'bg-gradient-to-r from-[#7ED34E] to-[#2E968A] text-white' : ''}`}>
                        <h3 className="text-[12px] font-medium">{tab.label}</h3>
                      </div>
                    )}
                  </div>
                </div>
                <h3 className="font-bold text-center w-full text-sm 2xl:text-xl">{graphName}</h3>
              </div>
              {selectedTableTab === 'graph' && <Area
                item={randomTag}
                type="tag"
                areaType="regular"
                renderType="lazyLoading"
                maintainAspectRatio={false}
                areaApiConfig={areaApiConfig}
              />}
            </div>
          </div>
        }
      </div>
    </div >
  );
};

export default SRACModal;